import Bussiness from "components/bussiness-tabs/Bussiness";
import { AiOutlinePlus } from "react-icons/ai";
import ManagementSidebar from "components/common/ManagementSidebar";
import styles from "../components/bussiness-tabs/bussiness.module.css";

import "./cstyle.css";
const MarketerPage = () => {
  return (
    <>
      <div></div>
      <div className=" w-100 mt-2 d-flex ">
        {/* <ManagementSidebar></ManagementSidebar> */}
        <div className="container">
          <div className="d-flex mx-3 justify-content-end">
            <button
              className={`btn  mx-1 mt-3 ${styles.btnHov}`}
              id=""
              style={{ background: "#CCEEF0", border: "#5EAAB7 1px solid" }}
              data-bs-toggle="modal"
              data-bs-target="#exampleModalAdd"
            >
              <div className="d-flex justify-content-around align-items-center text-center">
                <AiOutlinePlus />
                <p
                  className="textPro"
                  style={{ marginBottom: "0px", marginRight: "3px" }}
                >
                  {" "}
                  افزودن کسب و کار
                </p>
              </div>
            </button>
          </div>
          <Bussiness marketer={true} />
        </div>
      </div>
    </>
  );
};

export default MarketerPage;
